import { Shark } from "shark-mvc";

import SiteInfoSheetEditViewBase from "./SiteInfoSheetEditViewBase";

import templateContent from "./site-info-sheet-outdoor-edit.html";

import contactDetailsModalComponent from "../../components/contactDetailsModal/contactDetailsModalComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import siteInfoSheetOutdoorEditView from "./siteInfoSheetOutdoorEditView";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class SiteInfoSheetOutdoorDisplayView extends SiteInfoSheetEditViewBase {
	constructor () {
		super("siteInfoSheetOutdoorDisplayView");
		this.setTemplate(templateContent);
	}
	
	backToListBtn_clickHandler () {
		this.set("cancelEditsDestination", "siteInfoSheetListView");
		this.cancelEdits();
	}

	beforeLoad () {
		this.beforeLoadCommon("outdoor");
	}

	editBtn_clickHandler () {
		Shark.set({
			isEditingSiteInfoSheet: true,
		});
		Shark.openPage(siteInfoSheetOutdoorEditView);
	}

	init () {
		this.addComponents([contactDetailsModalComponent, exportPDFComponent, mainNavComponent, printButtonComponent, waitBoxComponent]);

		Shark.set({
			applicatorTeamList: Shark.get("applicatorTeamList") || [],
		});

		this.set({
			__htmlTitle: "Scheda Informativa | IPM HUB",
		});
	}
}

const siteInfoSheetOutdoorDisplayView = new SiteInfoSheetOutdoorDisplayView();

Shark.registerView(siteInfoSheetOutdoorDisplayView);

export default siteInfoSheetOutdoorDisplayView;
